import Button from '@/app/components/common/Button'
import Popup from '@/app/components/common/Popup'
import Title from '@/app/components/common/Title'
import { Icons } from '@/app/components/ui/Icons'
import { SM_BREAKPOINT } from '@/app/constants'
import { useMediaQuery } from '@uidotdev/usehooks'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import { FC, ReactNode } from 'react'
import { RemoveScroll } from 'react-remove-scroll'

interface LanguageAndCurrencyPopupProps {
	isOpen: boolean
	children: ReactNode
	onClose: () => void
	onSave: () => void
}

const LanguageAndCurrencyPopup: FC<LanguageAndCurrencyPopupProps> = ({
	isOpen,
	onClose,
	onSave,
	children,
}) => {
	const isMobile = useMediaQuery(SM_BREAKPOINT)
	const t = useTranslations('Header')

	return (
		<RemoveScroll enabled={isOpen && isMobile}>
			<Popup
				isOpen={isOpen}
				onClose={onClose}
				fullScreenMode
				className="w-screen min-h-screen fixed bg-text-100 left-0 top-0 flex flex-col"
			>
				<div className="px-3 py-6 flex items-center relative bg-white">
					<button
						className="w-10 h-10 p-2 -ms-2 -mt-2 me-auto absolute left-3 top-[26px]"
						onClick={onClose}
					>
						<Icons.iconClose />
					</button>
					{/* <Title level="5" bold className="mx-auto">
					Language & Currency
				</Title> */}
					<Title level="5" bold className="mx-auto">
						{t('currency')}
					</Title>
				</div>
				<div className="px-4 flex flex-col justify-between grow">
					<div className='max-w-screen-md mx-auto w-full'>{children}</div>
				</div>
				<div className="px-4 sticky left-0 bottom-12 w-full">
					<Button
						id="save-button"
						bold
						textColor="white"
						onClick={onSave}
						name="Save"
						fontSize="xl"
						className={classNames(
							'!bg-gradient-to-r h-14 from-main to-[#E02189] !rounded-full w-full max-w-screen-md mx-auto block'
						)}
					>
						{t('save')}
					</Button>
				</div>
			</Popup>
		</RemoveScroll>
	)
}

export default LanguageAndCurrencyPopup
